module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-92451506-4"],"gtagConfig":{}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"pricetrack","short_name":"pricetrack","start_url":"/?utm_source=homescreen&utm_medium=shortcut","background_color":"#faf9f5","theme_color":"#cc785c","display":"standalone","icon":"static/icon.png","include_favicon":true,"share_target":{"action":"add","method":"GET","params":{"title":"title","text":"text","url":"url"}},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"7b547dd973a300af1d1e6994471f9781"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
